import { Component, OnInit, signal, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MultiSelectModule } from 'primeng/multiselect';
import { DataViewLazyLoadEvent, DataViewModule } from 'primeng/dataview';
import { Institute } from '../../models/institute/randomInstituteResponse';
import { InstituteDetailSeachRequest } from '../../models/institute/instituteDetailSeachRequest';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FormsModule } from '@angular/forms';
import { InstituteSerachFilterComponent } from './institute-serach-filter/institute-serach-filter.component';
import { Store } from '@ngxs/store';
import { SkeletonModule } from 'primeng/skeleton';
import { RemoveMyInstitute, UpdateMyInstitutesList } from '../../states/myInstitutes/my-institute-actions';
import { CommonModule } from '@angular/common';
import { MyInstitutesSelectors } from '../../states/myInstitutes/my-institute-selector';
import { catchError, forkJoin, map, of, switchMap, take } from 'rxjs';
import { InstituteSearchItemComponent } from '../institute-search-item/institute-search-item.component';
import { UserStateModel } from '../../states/user/user-state-model';
import { UserSelectors } from '../../states/user/user-selector';
import { MyInstituteService } from '../../services/institute/myinstitute/my-institute.service';
import { AuthRoles } from '../../models/enums/enums';
import { ActivatedRoute, Router } from '@angular/router';
import { UserResponse } from '../../models/account/userResponse';
import { AuthService } from '../../services/account/auth.service';
import { MyInstituteRequest } from '../../models/institute/myInstituteRequest';
import { InstituteService } from '../../services/institute/institute.service';
import { SearchInstituteResponse } from '../../models/institute/searchInstituteResponse';
import { InstituteCourseSearchRequest } from '../../models/Institutedetails/filtersrequest';
import { ScholarshipsService } from '../../services/scholarships/scholarships.service';
import { ScholarshipResponse } from '../../models/scholarships/scholarshipResponse';
import { GetScholarshipRequest, ScholarshipType } from '../../models/scholarships/getScholarshipRequest';
import { MentorService } from '../../services/account/mentor.service';
import { MentorType } from '../../models/enums/enums';
import { UtilityService } from '../../services/utility/utility.service';
import { DialogModule } from 'primeng/dialog';
import { SliderModule } from 'primeng/slider';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputTextModule } from 'primeng/inputtext';
import { ChipModule } from 'primeng/chip';
import { StudentDirectApplicationService } from '../../services/student-direct-application/student-direct-application.service';
import { InstituteFilterCountRequest } from '../../models/institute/instituteFilterCountRequest';
import { InstituteFilterCountResponse } from '../../models/institute/instituteFilterCountResponse';
import { ContactPurpose } from '../../models/enums/contactUs';
import { ClarityCallPopupComponent } from '../../shared/components/clarity-call-popup/clarity-call-popup.component';
import { formatDeadline, parseDeadline } from '../../pipe/deadlinePipe';

interface SortOption { name: string; code: string; }

@Component({
  selector: 'app-institute-search',
  standalone: true,
  imports: [
    DataViewModule, ButtonModule, DropdownModule, FormsModule,
    AutoCompleteModule, DialogModule, SliderModule, OverlayPanelModule,
    InputTextModule, ChipModule, MultiSelectModule,
    InstituteSerachFilterComponent, SkeletonModule,
    CommonModule, InstituteSearchItemComponent, ClarityCallPopupComponent
  ],
  templateUrl: './institute-search.component.html',
  styleUrl: './institute-search.component.scss'
})
export class InstituteSearchComponent implements OnInit {
  allUniversitiesCount: number = 0;
  partnerUniversitiesCount: number = 0;


  @ViewChild('filterComponent') filterComponent?: InstituteSerachFilterComponent;

  activeTab: 'programmes' | 'universities' | 'scholarships' = 'universities';

  // Clarity Call dialog state
  showClarityCallDialog: boolean = false;
  ContactPurpose = ContactPurpose;

  collegeSearchName: any;
  searchSuggestions: any[] = [];

  sortlistOptions: SortOption[] = [
    { name: 'QS Ranking', code: 'qsRanking' },
    { name: 'NIRF Ranking', code: 'nirfRanking' }
  ];
  sortOrderOptions: SortOption[] = [
    { name: 'Ascending', code: 'ASC' },
    { name: 'Descending', code: 'DESC' }
  ];
  sortField: SortOption | undefined;
  sortOrder: SortOption | undefined;

  institutes = signal<Institute[]>([]);
  mentorSavedList = signal<Institute[]>([]);
  directAppliedList = signal<any[]>([]);
  total: number = 0;
  totalUniversities: number = 0;
  totalProgrammes: number = 0;
  totalScholarships: number = 0;
  loadingInstituteId: string | null = null;
  loadingData: boolean = false;
  firstItem: number = 0;
  rowSize: number = 9;
  instituteSearchRequest: InstituteDetailSeachRequest | undefined;
  courseSearchRequest: InstituteCourseSearchRequest | undefined;
  user!: UserStateModel;
  portal: string = '';
  applicantId: string | null = null;
  applicantDetails: UserResponse | null = null;

  // Scholarships variables
  scholarshipsList = signal<ScholarshipResponse[]>([]);
  allScholarshipsList = signal<ScholarshipResponse[]>([]);
  myScholarshipsList = signal<ScholarshipResponse[]>([]);
  myScholarshipsOnly = false;
  myInstitutesOnly = false;
  searchQuery = '';
  selectedCountries: string[] = [];
  selectedStreams: string[] = [];
  selectedLevels: string[] = ['All'];
  selectedDeadline: string | null = null;
  selectedAcademicEligibility = 0;
  selectedFundingTypes: string[] = ['All'];
  selectedFieldsOfStudy: string[] = [];
  schoplarshipNames: string[] = [];
  loadingScholarshipId?: number | null = null;
  scholarshipDialogVisible = false;
  selectedScholarship: ScholarshipResponse | null = null;
  studentMentors: any[] = [];
  selectedMentorToShare: any = null;
  isSharing = false;

  countryFilterOptions: string[] = [];
  streamFilterOptions: string[] = [];
  levelFilterOptions: string[] = [];
  deadlineFilterOptions: string[] = [];
  fundingTypeOptions: string[] = ['Tuition', 'Living', 'Loan Scholarship', 'Stipend'];
  fundingTypeOptionsAll: string[] = ['All', 'Tuition', 'Living', 'Loan Scholarship', 'Stipend'];
  selectedModes: string[] = ['All'];
  fieldsOfStudyOptions: string[] = [
    'Computer Science', 'Mechanical Engineering', 'Business Administration', 'Medicine',
    'Economics', 'Psychology', 'Architecture', 'Law', 'Arts & Humanities',
    'Environmental Science', 'Biotechnology', 'Journalism', 'Mathematics',
    'Physics', 'Chemistry', 'Sociology', 'Political Science', 'Education',
    'Hospitality Management', 'Design'
  ];

  degreeLevelOptions = ['All', 'Under Graduate', 'Post Graduate', 'PHD'];
  countryCodeMap: { [key: string]: string } = {};
  countryOptions: string[] = [];

  private countrySynonyms: { [key: string]: string[] } = {
    'united states of america': ['usa', 'us', 'united states', 'united states of america'],
    'united kingdom': ['uk', 'england', 'britain', 'great britain', 'united kingdom'],
    'united arab emirates': ['uae', 'united arab emirates', 'dubai', 'abu dhabi']
  };

  constructor(
    private store: Store,
    private instituteService: InstituteService,
    private myInstituteService: MyInstituteService,
    private route: ActivatedRoute,
    public router: Router,
    private authService: AuthService,
    private messageService: MessageService,
    private scholarshipsService: ScholarshipsService,
    private mentorService: MentorService,
    private utilityService: UtilityService,
    private studentDirectApplicationService: StudentDirectApplicationService
  ) { }

  ngOnInit(): void {
    this.applicantId = this.route.snapshot.paramMap.get('id') || '';

    // Load filter options from backend services
    this.getCountryOptions();
    this.getStreamOrLevelOptions();

    const tabParam = this.route.snapshot.queryParamMap.get('tab');
    if (tabParam === 'universities') {
      this.activeTab = 'universities';
    } else if (tabParam === 'programmes') {
      this.activeTab = 'programmes';
    } else if (tabParam === 'scholarships') {
      this.activeTab = 'scholarships';
    }

    const isDAPartnerParam = this.route.snapshot.queryParamMap.get('isDAPartner') === 'true';
    if (isDAPartnerParam) {
      this.instituteSearchRequest = { ...(this.instituteSearchRequest || {}), isDAPartner: true };
    }

    const searchParam = this.route.snapshot.queryParamMap.get('search');
    if (searchParam) {
      this.searchQuery = searchParam;
    }

    const levelParam = this.route.snapshot.queryParamMap.get('level');
    if (levelParam) {
      const lowerLvl = levelParam.toLowerCase().trim();
      if (lowerLvl === 'ug' || lowerLvl === 'undergraduate' || lowerLvl === 'under graduate') {
        this.selectedLevels = ['Under Graduate'];
      } else if (lowerLvl === 'pg' || lowerLvl === 'postgraduate' || lowerLvl === 'post graduate') {
        this.selectedLevels = ['Post Graduate'];
      } else if (lowerLvl === 'phd') {
        this.selectedLevels = ['PHD'];
      }
    }

    this.getUser();
    if (!this.applicantId) {
      if (this.activeTab === 'universities') {
        this.instituteSearchRequest = { ...(this.instituteSearchRequest || {}), pageNumber: 1, pageSize: this.rowSize };
        this.retriveInstitutes(this.instituteSearchRequest);
      } else if (this.activeTab === 'scholarships') {
        this.getScholarships();
      } else {
        this.retriveCourses();
      }
    } else {
      this.getApplicantDetails();
      if (this.activeTab === 'scholarships') {
        this.getScholarships();
      } else if (this.applicantId) {
        this.myInstituteService.getMyInstitutesByid(this.applicantId).subscribe({
          next: (response: any) => {
            const institutes = response.result || response;
            this.retriveInstitutesWithExternalSavedList(institutes);
          },
          error: (error) => console.warn('Error fetching applicant institutes:', error)
        });
      }
    }
  }

  onSearchComplete(event: { query: string }): void {
    if (event.query.length >= 2) {
      this.instituteService.searchInstitute(event.query).subscribe({
        next: (response: SearchInstituteResponse[]) => {
          this.searchSuggestions = response.length > 0 ? response : [{ name: event.query }];
        },
        error: () => { this.searchSuggestions = []; }
      });
    } else {
      this.searchSuggestions = [];
    }
  }

  onSearchSelect(): void {
    const searchName = typeof this.collegeSearchName === 'string' ? this.collegeSearchName : this.collegeSearchName?.name ?? null;

    this.instituteSearchRequest = {
      ...(this.instituteSearchRequest || {}),
      name: searchName,
      pageNumber: 1,
      pageSize: this.rowSize
    };

    this.courseSearchRequest = {
      ...(this.courseSearchRequest || {}),
      name: searchName,
      pageNumber: 1,
      pageSize: this.rowSize
    };

    if (this.activeTab === 'universities') {
      this.retriveInstitutes(this.instituteSearchRequest!);
    } else {
      this.retriveCourses();
    }
  }

  onSearchClear(): void {
    this.collegeSearchName = null;

    this.instituteSearchRequest = {
      ...(this.instituteSearchRequest || {}),
      name: null,
      pageNumber: 1,
      pageSize: this.rowSize
    };

    this.courseSearchRequest = {
      ...(this.courseSearchRequest || {}),
      name: null,
      pageNumber: 1,
      pageSize: this.rowSize
    };

    if (this.activeTab === 'universities') {
      this.retriveInstitutes(this.instituteSearchRequest!);
    } else {
      this.retriveCourses();
    }
  }

  onSearchEnter(): void {
    this.onSearchSelect();
  }

  onSortChange(): void {
    const sField = this.sortField?.code ?? null;
    const sOrder = this.sortOrder?.code ?? null;

    this.instituteSearchRequest = {
      ...(this.instituteSearchRequest || {}),
      sortField: sField,
      sortOrder: sOrder,
      pageNumber: 1,
      pageSize: this.rowSize
    };

    this.courseSearchRequest = {
      ...(this.courseSearchRequest || {}),
      sortField: sField,
      sortOrder: sOrder,
      pageNumber: 1,
      pageSize: this.rowSize
    };

    if (this.activeTab === 'programmes') {
      this.retriveCourses();
    } else {
      this.retriveInstitutes(this.instituteSearchRequest!);
    }
  }

  retriveInstitutesWithExternalSavedList(savedList: Institute[]) {
    this.mentorSavedList.set(savedList);
    this.instituteService.instituteDetailSearch(this.instituteSearchRequest!).subscribe({
      next: (response) => {
        const institutes = response.result.map(institute => ({
          ...institute,
          isMyInstitute: this.mentorSavedList().some(saved => saved.id === institute.id)
        }));
        this.institutes.set(institutes);
        this.total = response.total;
        this.totalUniversities = response.total;
      },
      error: (error) => console.warn('Error in searching institutes', error),
      complete: () => { this.loadingData = false; }
    });
  }

  getUser() {
    this.store.select(UserSelectors.getUser).subscribe({
      next: (response) => {
        this.user = response;
        if (this.user.role.includes(AuthRoles.Student)) this.portal = 'student';
        else if (this.user.role.includes(AuthRoles.Mentor)) this.portal = 'mentor';
        this.fetchDirectAppliedList();
      },
      error: (error) => console.warn('Error fetching user:', error)
    });
  }

  fetchDirectAppliedList() {
    const studentId = this.applicantId || this.getUserId();
    if (!studentId) return;
    this.studentDirectApplicationService.getByStudentId({ studentId }).subscribe({
      next: (response: any) => {
        let rawItems: any[] = [];
        if (Array.isArray(response)) {
          rawItems = response;
        } else if (response?.result) {
          rawItems = Array.isArray(response.result) ? response.result : [response.result];
        } else if (response && response.instituteId) {
          rawItems = [response];
        }
        this.directAppliedList.set(rawItems.map((item: any) => ({ instituteId: item.instituteId, courseId: item.courseId })));
      },
      error: () => { }
    });
  }

  getApplicantDetails() {
    if (!this.applicantId) return;
    this.authService.getUserByid(this.applicantId).subscribe({
      next: (response) => {
        this.applicantDetails = response;
        this.searchDetailInstitutes({ detailRequest: { pageNumber: 1, pageSize: this.rowSize } });
      },
      error: (error) => console.warn('Error fetching applicant details:', error)
    });
  }

  onLazyLoad($event: DataViewLazyLoadEvent) {
    const pageNumber = ($event.first / $event.rows) + 1;
    this.firstItem = $event.first;
    this.rowSize = $event.rows;

    if (this.activeTab === 'programmes') {
      this.courseSearchRequest = { ...this.courseSearchRequest, pageNumber: pageNumber, pageSize: $event.rows };
      this.retriveCourses();
    } else if (this.activeTab === 'universities') {
      this.instituteSearchRequest = { ...this.instituteSearchRequest, pageNumber, pageSize: $event.rows };
      this.retriveInstitutes(this.instituteSearchRequest);
    } else if (this.activeTab === 'scholarships') {
      this.getScholarships();
    }
  }
  searchDetailInstitutes(event: { detailRequest: InstituteDetailSeachRequest; courseRequest?: InstituteCourseSearchRequest }) {
    const searchName = typeof this.collegeSearchName === 'string' ? this.collegeSearchName : this.collegeSearchName?.name ?? null;

    // Preserve the current sort state set by the sort dropdowns
    const currentSortField = this.instituteSearchRequest?.sortField ?? null;
    const currentSortOrder = this.instituteSearchRequest?.sortOrder ?? null;

    this.instituteSearchRequest = {
      ...event.detailRequest,
      name: searchName,
      sortField: currentSortField,
      sortOrder: currentSortOrder,
      pageNumber: 1,
      pageSize: this.rowSize
    };

    this.courseSearchRequest = {
      ...(event.courseRequest || {}),
      name: searchName,
      sortField: this.courseSearchRequest?.sortField ?? null,
      sortOrder: this.courseSearchRequest?.sortOrder ?? null,
      pageNumber: 1,
      pageSize: this.rowSize
    };

    this.retriveInstitutes(this.instituteSearchRequest);
  }

  fetchFilterCounts() {
    if (this.activeTab === 'scholarships') return;

    const req: InstituteFilterCountRequest = { isForCourse: this.activeTab === 'programmes' };

    // Fetch both DA Abroad count (via filter-counts) and DA India count (via search) in parallel
    forkJoin([
      this.instituteService.getFilterCounts(req).pipe(catchError(() => of(null))),
      this.instituteService.instituteDetailSearch({ isDAPartner: true, country: 'India', pageNumber: 1, pageSize: 1 }).pipe(catchError(() => of(null)))
    ]).subscribe({
      next: ([abroadRes, indiaRes]) => {
        const data = (abroadRes as any)?.result ?? abroadRes;
        if (data) {
          this.allUniversitiesCount = data.allCount ?? data.AllCount ?? 0;
          const abroadCount = data.partnerCount ?? data.PartnerCount ?? 0;
          const indiaCount = (indiaRes as any)?.total ?? (indiaRes as any)?.result?.total ?? 0;
          this.partnerUniversitiesCount = abroadCount + indiaCount;
        }
      },
      error: (err) => console.warn('Error fetching filter counts', err)
    });
  }

  switchTab(tab: 'universities' | 'programmes' | 'scholarships') {
    if (this.activeTab !== tab) {
      this.activeTab = tab;
      this.firstItem = 0;
      this.rowSize = 9;

      // Reset filters when switching tabs
      if (this.filterComponent) {
        this.filterComponent.clearAllFilters();
      }

      // Reset search requests to defaults, keeping only the search name if we want, or clear completely
      this.instituteSearchRequest = { pageNumber: 1, pageSize: 9 };
      this.courseSearchRequest = { pageNumber: 1, pageSize: 9 };

      if (tab === 'universities') {
        this.retriveInstitutes(this.instituteSearchRequest);
      } else if (tab === 'programmes') {
        this.retriveCourses();
      } else if (tab === 'scholarships') {
        this.myScholarshipsOnly = false;
        this.getScholarships();
      }
    }
  }

  retriveInstitutes(instituteSearchRequest: InstituteDetailSeachRequest) {
    if (this.activeTab === 'programmes') {
      this.retriveCourses();
      return;
    }

    this.fetchFilterCounts();

    this.loadingData = true;

    if (this.myInstitutesOnly) {
      const source$ = this.applicantId
        ? of({ items: this.mentorSavedList() })
        : this.store.select(MyInstitutesSelectors.getMyInstitute);

      source$.pipe(take(1)).subscribe({
        next: (results: any) => {
          const savedItems = results.items || [];
          // Group by unique institute ID for the Universities view
          const uniqueInstitutes = new Map<string, any>();
          savedItems.forEach((item: any) => {
            if (!uniqueInstitutes.has(item.id)) {
              uniqueInstitutes.set(item.id, {
                ...item,
                isMyInstitute: true,
                isDirectApplied: this.checkIfDirectApplied(item.id)
              });
            }
          });
          const institutes = Array.from(uniqueInstitutes.values());
          this.institutes.set(institutes);
          this.total = institutes.length;
          this.totalUniversities = institutes.length;
          this.loadingData = false;
        },
        error: (error) => {
          console.warn('Error fetching saved institutes', error);
          this.loadingData = false;
        }
      });
      return;
    }

    if (!this.applicantId) {
      this.store.select(MyInstitutesSelectors.getMyInstitute).pipe(
        take(1),
        switchMap((results) =>
          this.instituteService.instituteDetailSearch(instituteSearchRequest).pipe(
            map(response => {
              let institutesList = response.result;
              if (this.filterComponent && this.filterComponent.daType === 'Abroad') {
                institutesList = institutesList.filter((i: any) => (i.country || '').toLowerCase() !== 'india');
              }

              const institutes = institutesList.map((institute: any) => {
                const savedItem = results.items.find((item: any) => item.id === institute.id);
                return {
                  ...institute,
                  isMyInstitute: !!savedItem,
                  isDirectApplied: this.checkIfDirectApplied(institute.id),
                  myInstituteId: savedItem?.myInstituteId,
                  courseId: savedItem?.courseId,
                  inTakeYear: savedItem?.inTakeYear ?? null,
                  courseLevel: savedItem?.courseLevel != null ? Number(savedItem.courseLevel) : null,
                };
              });
              return { institutes, total: response.total };
            })
          )
        )
      ).subscribe({
        next: ({ institutes, total }) => {
          this.institutes.set(institutes);
          this.total = total;
          this.totalUniversities = total;
          this.loadingData = false;
        },
        error: (error) => {
          console.warn('Error in searching institutes', error);
          this.loadingData = false;
        }
      });
    } else {
      this.retriveInstitutesWithExternalSavedList(this.mentorSavedList());
    }
  }

  // Maps the backend Currency enum (0=Dollar,1=Rupee,2=Euro,3=Pound) to a display symbol.
  private currencySymbol(currency: number | null | undefined): string {
    switch (currency) {
      case 0: return '$';
      case 1: return '₹';
      case 2: return '€';
      case 3: return '£';
      default: return '$';
    }
  }

  retriveCourses() {
    this.fetchFilterCounts();
    this.loadingData = true;

    if (this.myInstitutesOnly) {
      const source$ = this.applicantId
        ? of({ items: this.mentorSavedList() })
        : this.store.select(MyInstitutesSelectors.getMyInstitute);

      source$.pipe(take(1)).subscribe({
        next: (results: any) => {
          const savedItems = (results.items || []).filter((item: any) => item.courseId != null);
          const institutes = savedItems.map((item: any) => ({
            ...item,
            isMyInstitute: true
          }));
          this.institutes.set(institutes);
          this.total = institutes.length;
          this.totalProgrammes = institutes.length;
          this.loadingData = false;
        },
        error: (error) => {
          console.warn('Error fetching saved courses', error);
          this.loadingData = false;
        }
      });
      return;
    }

    const request = this.courseSearchRequest || { pageNumber: 1, pageSize: this.rowSize };

    const source$ = this.applicantId
      ? of({ items: this.mentorSavedList() })
      : this.store.select(MyInstitutesSelectors.getMyInstitute);
    source$.pipe(
      take(1),
      switchMap((results: any) =>
        this.instituteService.searchCourses(request).pipe(
          map(response => {
            let coursesList = response.result || [];
            if (this.filterComponent && this.filterComponent.daType === 'Abroad') {
              coursesList = coursesList.filter((i: any) => (i.country || '').toLowerCase() !== 'india');
            }

            const institutes: Institute[] = coursesList.map((res: any) => {
              const savedItem = results.items.find((item: any) =>
                item.id === res.instituteId &&
                (item.courseId === Number(res.id) || !item.courseId)
              );
              return {
                id: res.instituteId,
                instituteName: res.instituteName,
                country: res.country,
                city: res.city,
                logo: res.logo,
                image: res.coverImage || '',
                isMyInstitute: !!savedItem,
                myInstituteId: savedItem?.myInstituteId,
                courseId: Number(res.id),
                courseName: res.courseName,
                averageTutionFees: res.courseFees,
                courseLevel: !isNaN(Number(res.courseLevel)) ? Number(res.courseLevel) : null,
                currency: this.currencySymbol(res.currency),
                alumni: null,
                isPartner: res.isPartner,
                coverImage: res.coverImage,
                courseFormat: res.courseFormat,
                deliveryMode: res.deliveryMode,
                duration: res.duration != null ? res.duration + ' years' : '',
                qsRanking: res.qsRanking != null ? res.qsRanking : (res.instituteQsRanking != null ? res.instituteQsRanking : null),
                nirfRanking: res.nirfRanking != null ? res.nirfRanking : (res.instituteNirfRanking != null ? res.instituteNirfRanking : null),
                matchPercentage: res.matchPercentage ?? 71,
                reviewScore: res.reviewScore ?? 9.8,
                reviewCount: res.reviewCount ?? 1240
              };
            });
            return { institutes, total: response.total };
          })
        )
      )
    ).subscribe({
      next: ({ institutes, total }: { institutes: Institute[], total: number }) => {
        this.institutes.set(institutes);
        this.total = total;
        this.totalProgrammes = total;
        this.loadingData = false;
      },
      error: (error: any) => {
        console.warn('Error in searching courses', error);
        this.loadingData = false;
      }
    });
  }

  private getUserId(): string {
    if (this.user?.id) return this.user.id;
    try {
      const accountData = localStorage.getItem('account');
      if (accountData) {
        const account = JSON.parse(accountData);
        return account.userId || account.id || '';
      }
    } catch { }
    return '';
  }
  toggleMyInstitute($event: {
    instituteId: string, courseId: number | undefined,
    inTakeYear?: string, courseLevel?: number, mentorDeadline?: string | null
  }, isMyInstitute: boolean, index: number) {
    this.loadingInstituteId = $event.instituteId;

    if (isMyInstitute) {
      const studentId = this.applicantId || this.getUserId();
      this.store.dispatch(new RemoveMyInstitute({ instituteId: $event.instituteId, studentId })).subscribe({
        next: () => {
          const updatedInstitutes = [...this.institutes()];
          updatedInstitutes[index].isMyInstitute = false;
          updatedInstitutes[index].myInstituteId = null;
          updatedInstitutes[index].courseId = null;
          this.institutes.set(updatedInstitutes);
          if (this.applicantId) {
            this.mentorSavedList.set(this.mentorSavedList().filter(i => i.id !== $event.instituteId));
          }
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'College removed successfully' });
        },
        error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to remove college' }),
        complete: () => { this.loadingInstituteId = null; }
      });
    } else {
      const addModel: MyInstituteRequest = {
        studentId: this.applicantId || this.getUserId(),
        isAddedByMentor: !!this.applicantId,
        instituteId: $event.instituteId,
        courseId: $event.courseId || 0,
        inTakeYear: $event.inTakeYear ?? null,
        courseLevel: $event.courseLevel,
        mentorDeadline: $event.mentorDeadline
      };
      this.myInstituteService.addMyInstituteByRequestModel(addModel).subscribe({
        next: (postResponse: any) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'College saved successfully' });
          const normalizedYear = postResponse.inTakeYear || postResponse.intakeYear || addModel.inTakeYear || null;
          const normalizedLevel = postResponse.courseLevel != null ? Number(postResponse.courseLevel)
            : (addModel.courseLevel != null ? Number(addModel.courseLevel) : null);
          this.instituteService.getInstitute($event.instituteId).subscribe({
            next: (response) => {
              const enrichedInstitute: Institute = {
                ...this.institutes()[index],
                ...response,
                myInstituteId: postResponse.id,
                courseId: postResponse.courseId || addModel.courseId,
                inTakeYear: normalizedYear,
                courseLevel: normalizedLevel,
                isMyInstitute: true
              };
              this.store.dispatch(new UpdateMyInstitutesList(enrichedInstitute));
              const updatedInstitutes = [...this.institutes()];
              updatedInstitutes[index] = enrichedInstitute;
              this.institutes.set(updatedInstitutes);
              if (this.applicantId) {
                this.mentorSavedList.set([...this.mentorSavedList(), enrichedInstitute]);
                // Redirect back to student profile after saving college in mentor context
                this.router.navigate(['/mentor-portal/app-applicant-profile', this.applicantId]);
              }
            },
            error: () => {
              // Fallback if getInstitute fails but save succeeded
              const fallbackInstitute: Institute = {
                ...this.institutes()[index],
                myInstituteId: postResponse.id,
                courseId: postResponse.courseId || addModel.courseId,
                inTakeYear: normalizedYear,
                courseLevel: normalizedLevel,
                isMyInstitute: true
              };
              this.store.dispatch(new UpdateMyInstitutesList(fallbackInstitute));
              const updatedInstitutes = [...this.institutes()];
              updatedInstitutes[index] = fallbackInstitute;
              this.institutes.set(updatedInstitutes);
              if (this.applicantId) {
                this.mentorSavedList.set([...this.mentorSavedList(), fallbackInstitute]);
                // Redirect back to student profile even on enrichment failure
                this.router.navigate(['/mentor-portal/app-applicant-profile', this.applicantId]);
              }
            }
          });
        },
        error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save college' }),
        complete: () => { this.loadingInstituteId = null; }
      });
    }
  }

  addToDirectApply($event: { instituteId: string, courseId: number | undefined, inTakeYear?: string, courseLevel?: number, mentorDeadline?: string | null }, index: number) {
    const studentId = this.applicantId || this.getUserId();
    if (!studentId) return;

    this.loadingInstituteId = $event.instituteId;
    this.studentDirectApplicationService.addStudentDirectApplication({
      studentId: studentId,
      instituteId: $event.instituteId,
      courseLevel: $event.courseLevel ?? null,
      courseId: $event.courseId ?? null,
      inTakeYear: $event.inTakeYear ?? ''
    }).subscribe({
      next: (response: any) => {
        const created = response?.result;
        if (created || response) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Institute saved to direct apply successfully'
          });
          this.directAppliedList.set([...this.directAppliedList(), { instituteId: $event.instituteId, courseId: $event.courseId }]);
        }
        this.loadingInstituteId = null;
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to add college to Direct Apply.'
        });
        this.loadingInstituteId = null;
      }
    });
  }

  checkIfDirectApplied(instituteId: string, courseId?: number | null): boolean {
    return this.directAppliedList().some(item =>
      item.instituteId === instituteId && (courseId && item.courseId ? Number(item.courseId) === Number(courseId) : true)
    );
  }

  trackByInstituteId(index: number, item: Institute) { return item.id; }

  get activeFilters(): string[] {
    const filters: string[] = [];
    const req = this.activeTab === 'programmes' ? this.courseSearchRequest : this.instituteSearchRequest;
    if (!req) return filters;

    if (req.courseLevel != null) {
      const levelNames: { [key: number]: string } = { 0: 'High School', 1: 'Certificate', 2: 'Diploma', 3: 'Associate Degree', 4: 'Bachelor\'s', 5: 'Post Graduate Diploma', 6: 'Master\'s', 7: 'Doctorate/PhD' };
      filters.push(levelNames[req.courseLevel] || 'Level ' + req.courseLevel);
    }
    if (req.country) filters.push(req.country);
    if (req.degreePreference) filters.push(req.degreePreference);
    if (req.minCost || req.maxCost) {
      filters.push(`$${req.minCost || 0} - $${req.maxCost || 'Max'}`);
    }
    return filters;
  }

  // ==========================================
  // Lost Scholarship Methods Restored
  // ==========================================

  getScholarships() {
    this.loadingData = true;
    const pageNum = Math.floor(this.firstItem / this.rowSize) + 1;
    const pSize = this.rowSize || 9;

    if (this.myScholarshipsOnly) {
      this.scholarshipsService.getMyScholarships().subscribe({
        next: (response) => {
          const data = response ? response.result.map(item => ({
            ...item.scholarship,
            isMyScholarship: true
          })) : [];
          this.myScholarshipsList.set(data);
          this.applyScholarshipFilters();
          this.loadingData = false;
        },
        error: (err) => {
          this.loadingData = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: `Error Fetching My Scholarships: ${err}` });
        }
      });
    } else {
      const countries = this.selectedCountries.length > 0 ? this.selectedCountries : null;
      const levels = this.selectedLevels.includes('All') ? null : this.selectedLevels;
      const fundingTypes = this.selectedFundingTypes.includes('All') ? null : this.selectedFundingTypes;
      const streams = this.selectedStreams.length > 0 ? this.selectedStreams : null;
      const gpStreams = this.selectedFieldsOfStudy.length > 0 ? this.selectedFieldsOfStudy : null;

      const req: GetScholarshipRequest = {
        scholarshipName: this.searchQuery ? this.searchQuery.trim() : null,
        scholarshipType: ScholarshipType.Scholarship,
        countries: countries,
        levels: levels,
        academicEligibility: this.selectedAcademicEligibility > 0 ? this.selectedAcademicEligibility : null,
        fundingTypes: fundingTypes,
        streams: streams,
        gpStreams: gpStreams,
        sortField: 'deadline',
        sortOrder: 'asc',
        pageNumber: pageNum,
        pageSize: pSize
      };

      this.scholarshipsService.getScholarships(req).subscribe({
        next: (response) => {
          const data = response ? response.result.map(item => ({
            ...item,
            isMyScholarship: false
          })) : [];
          this.scholarshipsList.set(this.sortScholarshipsByCountry(data));
          this.total = response.total || data.length;
          this.totalScholarships = response.total || data.length;

          this.scholarshipsService.getMyScholarships().subscribe({
            next: (savedRes) => {
              const myScholarshipsIds = savedRes.result.map(s => s.scholarship.id);
              const updated = this.scholarshipsList().map(item => ({
                ...item,
                isMyScholarship: myScholarshipsIds.includes(item.id)
              }));
              this.scholarshipsList.set(this.sortScholarshipsByCountry(updated));
            },
            error: (err) => {
              console.warn('Error fetching my scholarships to mark bookmarks:', err);
            }
          });

          this.loadingData = false;
        },
        error: (err) => {
          this.loadingData = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: `Error Fetching Scholarships: ${err}` });
        }
      });
    }
  }

  private isCountryMatch(countryField: any): boolean {
    if (!this.selectedCountries || this.selectedCountries.length === 0) return false;
    if (!countryField) return false;
    const countries = (Array.isArray(countryField) ? countryField : [countryField])
      .filter(c => !!c)
      .map(c => (typeof c === 'string' ? c : (c.name || c.toString() || '')).toLowerCase().trim());

    return countries.some(sc =>
      this.selectedCountries.some(sel => {
        const selL = sel.toLowerCase().trim();
        if (sc === selL || sc.includes(selL) || selL.includes(sc)) return true;
        for (const canon in this.countrySynonyms) {
          const synonyms = this.countrySynonyms[canon];
          if (synonyms.includes(selL) && synonyms.includes(sc)) return true;
        }
        return false;
      })
    );
  }

  sortScholarshipsByCountry(list: ScholarshipResponse[]): ScholarshipResponse[] {
    if (!list || list.length === 0 || !this.selectedCountries || this.selectedCountries.length === 0) {
      return list;
    }

    const matching: ScholarshipResponse[] = [];
    const nonMatching: ScholarshipResponse[] = [];

    list.forEach(s => {
      if (this.isCountryMatch(s.country)) {
        matching.push(s);
      } else {
        nonMatching.push(s);
      }
    });

    return [...matching, ...nonMatching];
  }

  getMyScholarshipsList() {
    this.scholarshipsService.getMyScholarships().subscribe({
      next: (response) => {
        const myScholarshipsIds = response.result.map(s => s.scholarship.id);
        this.myScholarshipsList.set(response.result.map(item => ({
          ...item.scholarship,
          isMyScholarship: true
        })));
        const updated = this.scholarshipsList().map(item => ({
          ...item,
          isMyScholarship: myScholarshipsIds.includes(item.id)
        }));
        this.scholarshipsList.set(this.sortScholarshipsByCountry(updated));
      },
      error: (err) => {
        console.warn('Error fetching my scholarships:', err);
      }
    });
  }

  toggleMyScholarshipsMode(val: boolean) {
    this.myScholarshipsOnly = val;
    this.firstItem = 0;
    this.getScholarships();
  }

  toggleMyInstitutesMode(val: boolean) {
    this.myInstitutesOnly = val;
    this.firstItem = 0;
    if (this.activeTab === 'universities') {
      this.retriveInstitutes(this.instituteSearchRequest || { pageNumber: 1, pageSize: 9 });
    } else {
      this.retriveCourses();
    }
  }

  applyScholarshipFilters() {
    if (!this.myScholarshipsOnly) {
      this.firstItem = 0;
      this.getScholarships();
      return;
    }

    let filtered = [...this.myScholarshipsList()];

    if (this.searchQuery && this.searchQuery.trim().length > 0) {
      const q = this.searchQuery.toLowerCase().trim();
      filtered = filtered.filter(s =>
        (s.name || '').toLowerCase().includes(q) ||
        (s.description || '').toLowerCase().includes(q) ||
        (s.universityOrOrganisationName || '').toLowerCase().includes(q)
      );
    }

    if (this.selectedCountries && this.selectedCountries.length > 0) {
      filtered = filtered.filter(s => {
        if (!s.country) return false;
        const list = Array.isArray(s.country) ? s.country : [s.country];
        return list.some((c: any) => {
          const name = typeof c === 'string' ? c : (c.name || c.toString() || '');
          return this.selectedCountries.some((sel: string) => name.toLowerCase().includes(sel.toLowerCase()));
        });
      });
    }

    if (this.selectedLevels && this.selectedLevels.length > 0 && !this.selectedLevels.includes('All')) {
      const selectedLower = this.selectedLevels.map((d: string) => d.toLowerCase().trim());
      filtered = filtered.filter(s => {
        if (!s.level) return false;
        const lvl = s.level.toLowerCase().trim();
        return selectedLower.some((sel: string) => lvl.includes(sel) || sel.includes(lvl));
      });
    }

    if (this.selectedFundingTypes && this.selectedFundingTypes.length > 0 && !this.selectedFundingTypes.includes('All')) {
      const selectedLower = this.selectedFundingTypes.map((f: string) => f.toLowerCase().trim());
      filtered = filtered.filter(s => {
        if (!s.fundingType) return false;
        const list = Array.isArray(s.fundingType) ? s.fundingType : [s.fundingType];
        return list.some((f: any) => {
          const type = typeof f === 'string' ? f : (f.toString() || '');
          return selectedLower.some((sel: string) => type.toLowerCase().includes(sel));
        });
      });
    }

    if (this.selectedAcademicEligibility > 0) {
      filtered = filtered.filter(s => {
        if (!s.eligibility) return true;
        const reqs = s.eligibility.academicRequirements;
        if (!reqs || typeof reqs !== 'string') return true;
        const match = reqs.match(/(\d+)%/);
        if (match) {
          const val = parseInt(match[1], 10);
          return this.selectedAcademicEligibility >= val;
        }
        return true;
      });
    }

    if (this.selectedStreams && this.selectedStreams.length > 0) {
      const selectedLower = this.selectedStreams.map((st: string) => st.toLowerCase().trim());
      filtered = filtered.filter(s => {
        if (!s.stream) return false;
        const list = Array.isArray(s.stream) ? s.stream : [s.stream];
        return list.some((st: any) => selectedLower.includes(st.toLowerCase().trim()));
      });
    }

    if (this.selectedFieldsOfStudy && this.selectedFieldsOfStudy.length > 0) {
      const selectedLower = this.selectedFieldsOfStudy.map((f: string) => f.toLowerCase().trim());
      filtered = filtered.filter(s => {
        const gpStream = s.gpStream ? (Array.isArray(s.gpStream) ? s.gpStream : [s.gpStream]) : [];
        const gpSubBranch = s.gpSubBranch ? (Array.isArray(s.gpSubBranch) ? s.gpSubBranch : [s.gpSubBranch]) : [];
        const combined = [...gpStream, ...gpSubBranch].map((item: any) => item.toLowerCase().trim());
        return combined.some((item: string) => selectedLower.some((sel: string) => item.includes(sel) || sel.includes(item)));
      });
    }

    const sorted = this.sortScholarshipsByCountry(filtered);
    this.scholarshipsList.set(sorted);
    this.total = sorted.length;
    this.totalScholarships = sorted.length;
  }

  toggleMyScholarship(id: number) {
    if (this.loadingScholarshipId === id) return;
    this.loadingScholarshipId = id;
    const isSaved = this.myScholarshipsList().some(s => s.id === id);

    // Optimistic UI update
    this.scholarshipsList.update(list => list.map(s => s.id === id ? { ...s, isMyScholarship: !isSaved } : s));
    if (isSaved) {
      this.myScholarshipsList.update(list => list.filter(s => s.id !== id));
    }

    if (!isSaved) {
      this.scholarshipsService.addMyScholarship(id).subscribe({
        next: () => {
          this.loadingScholarshipId = null;
          this.getMyScholarshipsList();
          this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Scholarship saved to your list' });
        },
        error: () => {
          this.loadingScholarshipId = null;
          // Revert optimistic update on error
          this.scholarshipsList.update(list => list.map(s => s.id === id ? { ...s, isMyScholarship: isSaved } : s));
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save scholarship' });
        }
      });
    } else {
      this.scholarshipsService.deleteMyScholarShip(id).subscribe({
        next: () => {
          this.loadingScholarshipId = null;
          this.getMyScholarshipsList();
          this.messageService.add({ severity: 'success', summary: 'Removed', detail: 'Scholarship removed from your list' });
        },
        error: () => {
          this.loadingScholarshipId = null;
          // Revert optimistic update on error
          this.scholarshipsList.update(list => list.map(s => s.id === id ? { ...s, isMyScholarship: isSaved } : s));
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to remove scholarship' });
        }
      });
    }
  }

  openScholarshipDetails(scholarship: ScholarshipResponse): void {
    if (this.loadingScholarshipId) return;
    this.loadingScholarshipId = scholarship.id;
    this.scholarshipsService.getScholarshipById(scholarship.id).subscribe({
      next: (detailedScholarship) => {
        detailedScholarship.isMyScholarship = scholarship.isMyScholarship;
        this.selectedScholarship = detailedScholarship;
        this.scholarshipDialogVisible = true;
        this.loadingScholarshipId = null;
      },
      error: (err) => {
        this.loadingScholarshipId = null;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: `Error Fetching Scholarship Details: ${err}` });
      }
    });
  }

  closeScholarshipDialog(): void {
    this.scholarshipDialogVisible = false;
    this.selectedScholarship = null;
  }

  getAcademicMainText(reqs: any): string {
    if (!reqs || typeof reqs !== 'string') return "Bachelor's degree";
    const clean = reqs.trim();
    if (clean.includes('\n')) return clean.split('\n')[0].trim();
    if (clean.includes(';')) return clean.split(';')[0].trim();
    return clean;
  }

  getAcademicSubText(reqs: any): string | null {
    if (!reqs || typeof reqs !== 'string') {
      if (this.selectedScholarship?.id === 1 || (this.selectedScholarship?.name && this.selectedScholarship.name.includes('Fulbright'))) {
        return "3+ years work experience";
      }
      return null;
    }
    const clean = reqs.trim();
    if (clean.includes('\n')) return clean.split('\n')[1].trim();
    if (clean.includes(';')) return clean.split(';')[1].trim();
    if (this.selectedScholarship?.id === 1 || (this.selectedScholarship?.name && this.selectedScholarship.name.includes('Fulbright'))) {
      return "3+ years work experience";
    }
    return null;
  }

  getCountryDisplayName(country: any): string {
    if (!country) return 'Global';
    let name: any = Array.isArray(country) ? country[0] : country;
    if (!name) return 'Global';
    if (typeof name !== 'string') {
      name = name.name || name.toString() || '';
    }
    const lower = name.toLowerCase().trim();
    if (lower === 'united states' || lower === 'united states of america' || lower === 'us') {
      return 'USA';
    }
    if (lower === 'united kingdom' || lower === 'uk') {
      return 'UK';
    }
    return name;
  }

  getLevelDisplayName(level: any): string {
    if (!level || typeof level !== 'string') return 'Any';
    const lvl = level.toLowerCase().trim();
    if (lvl === 'post graduate' || lvl === 'pg' || lvl === 'postgraduate') return 'PG (Postgraduate)';
    if (lvl === 'under graduate' || lvl === 'ug' || lvl === 'undergraduate') return 'UG (Undergraduate)';
    if (lvl === 'phd' || lvl === 'doctorate') return 'PhD (Doctorate)';
    return level;
  }

  isCovered(type: 'tuition' | 'living' | 'travel' | 'health'): boolean {
    if (!this.selectedScholarship) return false;
    if (this.selectedScholarship.fullFunding) return true;

    let funding: any[] = [];
    if (Array.isArray(this.selectedScholarship.fundingType)) {
      funding = this.selectedScholarship.fundingType;
    } else if (typeof this.selectedScholarship.fundingType === 'string') {
      funding = [this.selectedScholarship.fundingType];
    }

    const fundingLower = funding
      .filter(f => typeof f === 'string')
      .map(f => f.toLowerCase().trim());

    if (type === 'tuition') {
      return fundingLower.some(f => f.includes('tuition') || f.includes('tution') || f.includes('full') || f.includes('stipend') || f.includes('fee'));
    }
    if (type === 'living') {
      return fundingLower.some(f => f.includes('living') || f.includes('full') || f.includes('stipend') || f.includes('accommodation'));
    }
    if (type === 'travel') {
      return fundingLower.some(f => f.includes('travel') || f.includes('full') || f.includes('airfare'));
    }
    if (type === 'health') {
      return fundingLower.some(f => f.includes('health') || f.includes('full') || f.includes('insurance') || f.includes('medical'));
    }
    return false;
  }

  getCoverageType(): string {
    if (!this.selectedScholarship) return '';
    if (this.selectedScholarship.fullFunding) return 'Full • 100%';

    let coveredCount = 0;
    if (this.isCovered('tuition')) coveredCount++;
    if (this.isCovered('living')) coveredCount++;
    if (this.isCovered('travel')) coveredCount++;
    if (this.isCovered('health')) coveredCount++;

    if (coveredCount === 0) return 'Partial';
    return `Partial • ${coveredCount * 25}%`;
  }

  getDeadlineDisplay(deadLine: any): string {
    if (!deadLine) return 'Varies';
    // GP-CB-05: when there is an exact deadline, show it in the fixed format ("March 31, 2026") instead of month + date.
    if (typeof deadLine !== 'string') {
      const exact = parseDeadline(deadLine.exactDate || deadLine.ExactDate || deadLine.exactdate);
      if (exact) return formatDeadline(exact);
    }

    let displayStr = '';
    if (typeof deadLine === 'string') {
      displayStr = deadLine;
    } else {
      const monthVal = deadLine.month || deadLine.Month;
      const dateVal = deadLine.exactDate || deadLine.ExactDate || deadLine.exactdate || '';

      if (!monthVal) return 'Varies';
      const month = this.formatMonth(monthVal);
      const date = dateVal ? ` ${dateVal}` : '';
      displayStr = `${month}${date}`;
    }

    let clean = displayStr.split('T')[0];
    clean = clean.replace(/\b\d{1,2}:\d{2}(?::\d{2})?\s*(?:AM|PM|am|pm)?/gi, '');
    clean = clean.replace(/\b(?:AM|PM|am|pm)\b/gi, '');
    clean = clean.replace(/\s+/g, ' ').trim();
    if (clean.endsWith(',')) {
      clean = clean.slice(0, -1).trim();
    }
    return clean;
  }

  getCountryPillName(country: any): string {
    if (!country) return 'Global';
    let name: any = Array.isArray(country) ? country[0] : country;
    if (!name) return 'Global';
    if (typeof name !== 'string') {
      name = name.name || name.toString() || 'Global';
    }
    const lower = name.toLowerCase().trim();
    if (lower === 'usa' || lower === 'us' || lower === 'united states' || lower === 'united states of america') {
      return 'United States';
    }
    if (lower === 'uk' || lower === 'united kingdom') {
      return 'United Kingdom';
    }
    return name;
  }

  getStreamDisplayName(stream: any): string {
    if (!stream) return 'Varies';
    if (Array.isArray(stream)) {
      return stream.join(', ');
    }
    if (typeof stream !== 'string') {
      return stream.toString() || 'Varies';
    }
    return stream;
  }

  shareWithMentorDirect(item: ScholarshipResponse) {
    this.selectedScholarship = item;
    if (this.studentMentors.length > 0) {
      this.selectedMentorToShare = this.studentMentors[0];
      this.isSharing = true;
      setTimeout(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Shared',
          detail: `Scholarship shared with ${this.selectedMentorToShare.label}`
        });
        this.isSharing = false;
        this.selectedMentorToShare = null;
        this.router.navigate(['/portal/chat']);
      }, 1000);
    } else {
      this.router.navigate(['/portal/mentor-me']);
    }
  }

  shareScholarshipWithMentor() {
    if (!this.selectedMentorToShare || !this.selectedScholarship) return;
    this.isSharing = true;
    setTimeout(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Shared',
        detail: `Scholarship shared with ${this.selectedMentorToShare.label}`
      });
      this.isSharing = false;
      this.selectedMentorToShare = null;
    }, 1000);
  }

  navigateToMentors() {
    this.closeScholarshipDialog();
    this.router.navigate(['/portal/mentor-me']);
  }

  bookClarityCall() {
    this.showClarityCallDialog = true;
  }

  removeScholarshipFilterChip(type: string, value?: string) {
    if (type === 'country' && value) {
      this.selectedCountries = this.selectedCountries.filter((v: string) => v !== value);
    } else if (type === 'stream' && value) {
      this.selectedStreams = this.selectedStreams.filter((v: string) => v !== value);
    } else if (type === 'level' && value) {
      this.selectedLevels = this.selectedLevels.filter((v: string) => v !== value);
    } else if (type === 'funding' && value) {
      this.selectedFundingTypes = this.selectedFundingTypes.filter((v: string) => v !== value);
    } else if (type === 'field' && value) {
      this.selectedFieldsOfStudy = this.selectedFieldsOfStudy.filter((v: string) => v !== value);
    } else if (type === 'deadline') {
      this.selectedDeadline = null;
    }
    this.applyScholarshipFilters();
  }

  filterScholarshipNames(event: any) {
    if (event.query.length > 2) {
      this.scholarshipsService.listScholarShipsName_ByInitials(event.query).subscribe({
        next: (response) => {
          this.schoplarshipNames = response.result;
        }
      });
    } else {
      this.schoplarshipNames = [];
    }
  }

  resetFilters(): void {
    this.firstItem = 0;
    this.selectedCountries = [];
    this.selectedStreams = [];
    this.selectedLevels = ['All'];
    this.selectedDeadline = null;
    this.selectedAcademicEligibility = 0;
    this.selectedFundingTypes = ['All'];
    this.selectedFieldsOfStudy = [];
    this.selectedModes = ['All'];
    this.searchQuery = '';
    this.applyScholarshipFilters();
  }

  toggleLevelFilter(opt: string) {
    if (opt === 'All') {
      this.selectedLevels = ['All'];
    } else {
      this.selectedLevels = this.selectedLevels.filter((v: string) => v !== 'All');
      if (this.selectedLevels.includes(opt)) {
        this.selectedLevels = this.selectedLevels.filter((v: string) => v !== opt);
      } else {
        this.selectedLevels.push(opt);
      }
      if (this.selectedLevels.length === 0) {
        this.selectedLevels = ['All'];
      }
    }
  }

  toggleFundingTypeFilter(type: string) {
    if (type === 'All') {
      this.selectedFundingTypes = ['All'];
    } else {
      this.selectedFundingTypes = this.selectedFundingTypes.filter((v: string) => v !== 'All');
      if (this.selectedFundingTypes.includes(type)) {
        this.selectedFundingTypes = this.selectedFundingTypes.filter((v: string) => v !== type);
      } else {
        this.selectedFundingTypes.push(type);
      }
      if (this.selectedFundingTypes.length === 0) {
        this.selectedFundingTypes = ['All'];
      }
    }
  }

  toggleModeFilter(mode: string) {
    if (mode === 'All') {
      this.selectedModes = ['All'];
    } else {
      this.selectedModes = this.selectedModes.filter((v: string) => v !== 'All');
      if (this.selectedModes.includes(mode)) {
        this.selectedModes = this.selectedModes.filter((v: string) => v !== mode);
      } else {
        this.selectedModes.push(mode);
      }
      if (this.selectedModes.length === 0) {
        this.selectedModes = ['All'];
      }
    }
  }

  formatMonth(month: string | null | undefined): string {
    if (!month) return 'Varies';
    const m = month.toLowerCase().trim();
    const map: { [key: string]: string } = {
      'jan': 'January', 'january': 'January',
      'feb': 'February', 'february': 'February',
      'mar': 'March', 'march': 'March',
      'apr': 'April', 'april': 'April',
      'may': 'May',
      'jun': 'June', 'june': 'June',
      'jul': 'July', 'july': 'July',
      'aug': 'August', 'august': 'August',
      'sep': 'September', 'september': 'September',
      'oct': 'October', 'october': 'October',
      'nov': 'November', 'november': 'November',
      'dec': 'December', 'december': 'December'
    };
    return map[m] || (month.charAt(0).toUpperCase() + month.slice(1).toLowerCase());
  }

  getCountryFlag(country: string | string[] | null | undefined): string | null {
    if (!country) return null;
    const name = Array.isArray(country) ? country[0] : country;
    if (!name) return null;

    if (name.toLowerCase() === 'global') {
      return null;
    }

    const code = this.countryCodeMap[name.toLowerCase()];
    if (code) {
      return `https://flagcdn.com/w40/${code}.png`;
    }

    const common: { [key: string]: string } = {
      'usa': 'us', 'uk': 'gb', 'india': 'in', 'canada': 'ca', 'australia': 'au',
      'germany': 'de', 'france': 'fr', 'china': 'cn', 'japan': 'jp'
    };
    const fallbackCode = common[name.toLowerCase()];
    return fallbackCode ? `https://flagcdn.com/w40/${fallbackCode}.png` : null;
  }

  getScholarshipImage(item: any): string | null {
    if (!item) return null;
    if (item.image && typeof item.image === 'string') {
      const img = item.image.trim();
      const isUrl = img.startsWith('http://') || img.startsWith('https://');
      if (isUrl) {
        return img;
      }
    }
    return null;
  }

  getFormattedAmount(item: any): string {
    if (!item) return 'Varies';

    // 1. Prioritize USD (currency === 0) from the amount array
    let amtStr = '';
    const amounts = item.scholarship?.amount || [];
    const usdAmountObj = amounts.find((a: any) => a.currency === 0);

    if (usdAmountObj && usdAmountObj.amount) {
      amtStr = usdAmountObj.amount.toString().trim();
    } else if (amounts.length > 0 && amounts[0].amount) {
      amtStr = amounts[0].amount.toString().trim();
    } else if (item.scholarshipAmount) {
      amtStr = item.scholarshipAmount.toString().trim();
    } else if (item.scholarship?.exactNumbersUnavailable) {
      amtStr = item.scholarship.exactNumbersUnavailable.toString().trim();
    }

    if (!amtStr) {
      if (item.fullFunding) return 'Full Funding';
      return 'Varies';
    }

    const lowerAmt = amtStr.toLowerCase();
    if (lowerAmt === 'varies' || lowerAmt === 'variable' || lowerAmt === 'varies/variable' || lowerAmt === 'varies / variable') {
      if (item.fullFunding) return 'Full Funding';
      return 'Varies';
    }

    // Strip currency symbols and commas to check if it's purely numeric
    const numericClean = amtStr.replace(/[$\u00A3\u20AC\u20B9\u20A8,\s]/g, '');
    if (/^\d+(\.\d+)?$/.test(numericClean)) {
      const num = parseFloat(numericClean);
      // Prepend original currency symbol if it was present
      if (amtStr.includes('£') || amtStr.includes('\u00A3')) {
        return '£' + num.toLocaleString('en-US', { maximumFractionDigits: 0 });
      }
      if (amtStr.includes('€') || amtStr.includes('\u20AC')) {
        return '€' + num.toLocaleString('en-US', { maximumFractionDigits: 0 });
      }
      if (amtStr.includes('₹') || amtStr.includes('\u20B9')) {
        return '₹' + num.toLocaleString('en-US', { maximumFractionDigits: 0 });
      }
      return '$' + num.toLocaleString('en-US', { maximumFractionDigits: 0 });
    }

    if (/^[\$\£\€\¥\₹]/.test(amtStr)) {
      return amtStr;
    }

    return amtStr;
  }

  getCountryOptions(): void {
    // 1. Get active countries available in the database
    this.scholarshipsService.getCountry().subscribe({
      next: (countryResponse) => {
        const activeCountries = countryResponse.result || [];

        // 2. Load all country codes to populate flag map
        this.utilityService.getCountries().subscribe({
          next: (response) => {
            if (response.result) {
              response.result.forEach(c => {
                this.countryCodeMap[c.name.toLowerCase()] = c.countryCode.toLowerCase();
              });
            }

            // Set the options to the exact database country names
            this.countryOptions = activeCountries;
            this.countryFilterOptions = this.countryOptions;

            // Re-check query param for country match now that options are loaded
            const countryParam = this.route.snapshot.queryParamMap.get('country') || this.route.snapshot.queryParams['country'];
            if (countryParam) {
              let matched = this.countryFilterOptions.find(c => c.toLowerCase() === countryParam.toLowerCase());

              if (!matched) {
                const canonical = Object.keys(this.countrySynonyms).find(key =>
                  this.countrySynonyms[key].includes(countryParam.toLowerCase())
                );
                if (canonical) {
                  matched = this.countryFilterOptions.find(c => c.toLowerCase() === canonical.toLowerCase() ||
                    this.countrySynonyms[canonical].includes(c.toLowerCase())
                  );
                }
              }

              if (matched) {
                this.selectedCountries = [matched];
                if (this.activeTab === 'scholarships') {
                  this.applyScholarshipFilters();
                }
              }
            }
          },
          error: (err) => console.warn('Error loading country codes:', err)
        });
      },
      error: (err) => console.warn('Error loading active countries:', err)
    });
  }

  getStreamOrLevelOptions() {
    this.scholarshipsService.getStream().subscribe({
      next: (response: any) => {
        this.streamFilterOptions = response.result;
      },
      error: (err: any) => console.warn('Error fetching stream options:', err)
    });
    this.scholarshipsService.getLevel().subscribe({
      next: (response: any) => {
        this.levelFilterOptions = response.result;
      },
      error: (err: any) => console.warn('Error fetching level options:', err)
    });
  }

  private searchTimeout: any;

  onScholarshipSearchChange(): void {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.applyScholarshipFilters();
    }, 400); // 400ms debounce to avoid spamming requests
  }

  exploreAllScholarships() {
    this.router.navigate(['/portal/scholarships']);
  }
}